module.exports = __webpack_public_path__ + "static/media/DLF - Flat Logo Branco.8abd2366.svg";